import React, { useState, useEffect } from 'react';
import { assignAssetForCustomer, searchAssetsForWorkshop } from '../../Api/Api';
import { useWorkshop } from '../Common/WorkshopContext';

const AssignAssetModal = ({ show, customerId, onClose, onAssign }) => {
    const [query, setQuery] = useState('');
    const [type, setType] = useState('');
    const [assets, setAssets] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const { workshopId } = useWorkshop();

    useEffect(() => {
        if (show) fetchAssets();
    }, [query, type, page, show]);

    const fetchAssets = () => {
        searchAssetsForWorkshop(workshopId, query, type, page)
            .then(res => {
                setAssets(res.data.content);
                setTotalPages(res.data.totalPages);
            });
    };

    const handleAssign = async (assetId) => {
        await assignAssetForCustomer({
            customerId,
            assetId,
            assignedDate: new Date().toISOString().slice(0, 10),
        });
        onAssign();
        onClose();
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-[800px] max-h-[90vh] overflow-y-auto">
                <h2 className="text-xl font-bold mb-4">Assign Asset</h2>

                {/* Search and Filter */}
                <div className="flex gap-2 mb-4">
                    <input
                        className="border px-3 py-2 rounded-lg w-full"
                        placeholder="Search by name or serial number"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                    <select
                        className="border px-3 py-2 rounded-lg"
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                    >
                        <option value="">All Types</option>
                        <option value="VEHICLE">Vehicle</option>
                        <option value="BATTERY">Battery</option>
                        <option value="CHARGER">Charger</option>
                        <option value="MOTOR">Motor</option>
                    </select>
                </div>

                {/* Asset Table */}
                <table className="w-full text-sm border">
                    <thead>
                    <tr className="bg-gray-100">
                        <th className="p-2 text-left">Name</th>
                        <th className="p-2 text-left">Type</th>
                        <th className="p-2 text-left">Serial</th>
                        <th className="p-2 text-left">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {assets.map((asset) => (
                        <tr key={asset.id} className="border-t">
                            <td className="p-2">{asset.name}</td>
                            <td className="p-2">{asset.assetType}</td>
                            <td className="p-2">{asset.serialNumber}</td>
                            <td className="p-2">
                                <button
                                    className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                                    onClick={() => handleAssign(asset.id)}
                                >
                                    Assign
                                </button>
                            </td>
                        </tr>
                    ))}
                    {assets.length === 0 && (
                        <tr>
                            <td colSpan="4" className="p-4 text-center text-gray-500">
                                No assets found
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>

                {/* Pagination + Footer */}
                <div className="flex justify-between items-center mt-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                    >
                        Cancel
                    </button>
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                            disabled={page === 0}
                            className="text-sm px-3 py-1 border rounded disabled:opacity-50"
                        >
                            Prev
                        </button>
                        <span className="text-sm">
                            Page {page + 1} of {totalPages}
                        </span>
                        <button
                            onClick={() => setPage((prev) => prev + 1)}
                            disabled={page + 1 >= totalPages}
                            className="text-sm px-3 py-1 border rounded disabled:opacity-50"
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssignAssetModal;
